const validateEmail = function (value) {
  if (value === null) {
    this.validEmail = false;
    return false;
  } if (value === '') {
    this.validEmail = false;
    this.dataError.email = 'Пожалуйста, введите адрес электронной почты.';
    // eslint-disable-next-line consistent-return
    return false;
  } if (value.indexOf('@') === -1) {
    this.validEmail = false;
    this.dataError.email = 'Адрес электронной почты должен содержать символ "@".';
    // eslint-disable-next-line consistent-return
    return false;
  } if (value.split('@')[0].length === 0) {
    this.validEmail = false;
    this.dataError.email = 'Введите часть адреса до символа "@".';
    // eslint-disable-next-line consistent-return
    return false;
  } if (value.split('@')[1].length === 0) {
    this.validEmail = false;
    this.dataError.email = 'Введите часть адреса после символа "@".';
    // eslint-disable-next-line consistent-return
    return false;
  } if (!((/\S+@\S+\.\S+/).test(value))) {
    this.validEmail = false;
    this.dataError.email = 'Пожалуйста, укажите правильный e-mail';
    // eslint-disable-next-line consistent-return
    return false;
  }
  this.validEmail = true;
  // eslint-disable-next-line consistent-return
  return true;
};

const validatePhone = function () {
  const value = this.unmaskedPhone;
  const valueMasked = this.valuePhone;
  if (value === null) {
    this.validPhone = false;
    return false;
  }
  if (String(value).length === 0) {
    this.dataError.phone = 'Обязательно для заполнения';
    this.validPhone = false;
    return false;
  }
  if (String(valueMasked).indexOf('_') !== -1) {
    this.dataError.phone = 'Пожалуйста, введите номер полностью';
    this.validPhone = false;
    return false;
  }
  if (String(value).substr(0, 2) === '89') {
    this.dataError.phone = 'Код номера телефона не может начинаться с "89"';
    this.validPhone = false;
    return false;
  }
  this.validPhone = true;
  return true;
};

const validateSite = function (value) {
  if (!value) return true;
  // eslint-disable-next-line max-len
  const RegExp = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-/])*)?/;

  return RegExp.test(value);
};
const validateSocialMediaSymbols = function (valueDefault) {
  if (!valueDefault) return true;
  const value = valueDefault.trim().replace(/^(www\.|https:\/\/|http:\/\/)/gi, '');
  // eslint-disable-next-line
  let symbolsRegexp = /^[-0-9A-ZА-ЯёЁ\/.]+$/ui;
  // eslint-disable-next-line
  symbolsRegexp = /^[-0-9A-ZА-ЯёЁ\/._?%&=@]+$/ui;
  const urlRegexp = /^(([A-ZА-ЯёЁ0-9][A-ZА-ЯёЁ0-9_-]*)(\.[A-ZА-ЯёЁ0-9][A-ZА-ЯёЁ0-9_-]*)+)/ui;

  return symbolsRegexp.test(value) && urlRegexp.test(value);
};

const validateEmailBackend = function (value) {
  // eslint-disable-next-line
  const reg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/gm
  return  reg.test(value)
}

export {
  validateEmail,
  validatePhone,
  validateSite,
  validateSocialMediaSymbols,
  validateEmailBackend,
};
